import { Pipe, PipeTransform } from '@angular/core';
import {Condition} from '../../afb-api/enums/condition.enum';

@Pipe({
  name: 'scoreToCondition'
})
export class ScoreToConditionPipe implements PipeTransform {

  transform(score: number): Condition {
    if (score != null) {
      return score < 60 ? Condition.Poor :
        score < 80 ? Condition.Fair : Condition.Good;
    } else {
      return Condition.Disconnected;
    }
  }
}
